var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commonPag"},[_c('el-pagination',{attrs:{"background":_vm.background,"page-size":_vm.pageSize,"layout":"total, prev, pager, next","total":_vm.total,"current-page":_vm.currentPage},on:{"size-change":_vm.onSizeChange,"current-change":_vm.currentChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e303bfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commonPag.vue
// module id = null
// module chunks = 